import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.schedule = () => {
      cancelAnimationFrame(this.frame)
      this.frame = requestAnimationFrame(() => this.layout())
    }
    this.resizeObserver = new ResizeObserver(this.schedule)
    this.resizeObserver.observe(this.element)
    Array.from(this.element.children).forEach(card => this.resizeObserver.observe(card))
    this.visibilityObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type !== "childList" || mutation.target !== this.element) return
        mutation.removedNodes.forEach(card => {
          if (card.nodeType === Node.ELEMENT_NODE) this.resizeObserver.unobserve(card)
        })
        mutation.addedNodes.forEach(card => {
          if (card.nodeType === Node.ELEMENT_NODE) this.resizeObserver.observe(card)
        })
      })
      this.schedule()
    })
    this.visibilityObserver.observe(this.element, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden"] })
    this.layout()
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
    this.resizeObserver.disconnect()
    this.visibilityObserver.disconnect()
  }

  layout() {
    const gap = parseFloat(getComputedStyle(this.element).getPropertyValue("--waterfall-gap"))
    const cards = Array.from(this.element.children).filter(card => !card.hidden)
    // Measure before writing; align-items keeps cards at their intrinsic height.
    const heights = cards.map(card => card.offsetHeight)
    cards.forEach((card, index) => {
      card.style.gridRowEnd = `span ${Math.ceil(heights[index] + gap)}`
    })
    this.element.classList.add("waterfall-ready")
  }
}
